import type { PricingCampaignDuplicationResultModel } from '../model/types'

import React from 'react'
import { ChevronDownIcon } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { useDisclosure } from '@/shared/hooks/use-disclosure'

export const PricingCampaignManagementResults = ({
	response,
}: {
	response?: PricingCampaignDuplicationResultModel[]
}) => {
	const panel = useDisclosure()
	if (!response) {
		return null
	}

	return (
		<div className='flex w-full flex-col'>
			<Button variant='ghost' size='sm' onClick={panel.toggle}>
				Details
				<ChevronDownIcon className='shrink-0 opacity-50' />
			</Button>
			{panel.isOpen && (
				<div className='space-y-1 rounded-lg bg-secondary p-3 text-left'>
					{response
						?.filter((item) => !item.success)
						?.map((item, i) => (
							<div key={`${item.message}_${i}`} className='text-sm'>
								{item.message}
							</div>
						))}
				</div>
			)}
		</div>
	)
}
